import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Row,
  Col
} from "reactstrap";

class TimelineHeader extends React.Component {

  onHomeCliecked = e => {
    e.preventDefault()
    this.props.history.push("/admin/publicacoes");
  }

  render() {
    return (
      <>
        <div
          style={{
            background: "transparent",
            boxShadow: "none",
          }}
          className="header pb-0"
        >
          <Container fluid>
            <div className="header-body">
            </div>
          </Container>
        </div>
      </>
    );
  }
}

TimelineHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string
};

export default TimelineHeader;
